import React, { useState } from 'react'
import { Container } from 'theme-ui'
import LoginForm from './LoginForm'
import RegisterForm from './RegisterForm'
import ResetForm from './ResetForm'

function AccountForm() {
  const [activeForm, setActiveForm] = useState('login')
  return (
    <>
      <Container sx={{ px: 3, maxWidth: 500, py: [6, 7] }}>
        {activeForm == 'login' && (
          <LoginForm
            setActiveForm={setActiveForm}
          />
        )}
        {activeForm == 'reset' && (
          <ResetForm
            setActiveForm={setActiveForm}
          />
        )}
      </Container>
    </>
  )
}

export default AccountForm